type Props = {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  placeholder?: string;
};

/**
 * Minimal composer: soft field + high-contrast send (Eleven-style chat bar).
 */
export function ChatInput({ value, onChange, onSubmit, disabled, placeholder }: Props) {
  return (
    <form
      className="shrink-0"
      onSubmit={(e) => {
        e.preventDefault();
        if (!disabled && value.trim()) onSubmit();
      }}
    >
      <label htmlFor="geofleet-public-chat-input" className="sr-only">
        Message
      </label>
      <div className="flex min-h-[44px] items-center gap-1.5 rounded-full border border-neutral-200/90 bg-neutral-50/80 px-1 py-1 pl-3 transition-[box-shadow,border-color] focus-within:border-neutral-300 focus-within:bg-white focus-within:shadow-sm sm:min-h-[48px] sm:gap-2 sm:px-1.5 sm:pl-3.5">
        <input
          id="geofleet-public-chat-input"
          type="text"
          autoComplete="off"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder ?? 'Type your message…'}
          className="min-h-[34px] min-w-0 flex-1 border-0 bg-transparent text-[14px] text-neutral-900 outline-none ring-0 placeholder:text-neutral-400 disabled:opacity-50 sm:min-h-[38px] sm:text-[15px]"
        />
        <button
          type="submit"
          disabled={disabled || !value.trim()}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-neutral-950 text-white transition hover:bg-neutral-800 disabled:pointer-events-none disabled:bg-neutral-200 disabled:text-neutral-400 sm:h-10 sm:w-10"
          aria-label="Send message"
        >
          <i className="ri-arrow-up-line text-lg font-semibold sm:text-xl" aria-hidden />
        </button>
      </div>
    </form>
  );
}
